export default __webpack_public_path__ + "static/media/shirt.44f8914a.jpg";